<div [formGroup]="group">
  <div [formArrayName]="arrayName" layout-vertical [attr.margin-top-small]="!hasNewStyling || null">
    @for (
      control of arrayControls.controls;
      track trackByValue(i, control);
      let i = $index;
      let isLast = $last;
      let isFirst = $first
    ) {
      <div
        [attr.margin-bottom-small]="!isLast || null"
        [attr.margin-bottom-small-xx]="isLast || null"
      >
        <rt-group variant="horizontal">
          @if (editPhoneNumber) {
            <rt-phone-input
              #inputField
              [formControlName]="i"
              [countryCode]="countryCode"
              placeholder="{{ 'app.common.type_here' | translate }}"
              layout-full-width
            ></rt-phone-input>
          } @else {
            <rt-input
              #inputField
              [formControlName]="i"
              [autoFocus]="isFirst"
              [invalid]="control.invalid && control.touched"
              (blur)="onBlur(arrayControls.controls[i])"
              placeholder="{{ 'app.common.type_here' | translate }}"
              [attr.data-cy]="'profile-information-edit:input:' + arrayName"
            ></rt-input>
          }
          @if (arrayControls.length > 1) {
            <rt-icon-button
              (click)="onRemove(i)"
              variant="plain"
              shape="square"
              iconName="close"
              class="icon-danger-on-hover"
              margin-left-small-xx
            ></rt-icon-button>
          }
        </rt-group>
        @if (errorText && control.invalid && control.touched) {
          <div class="error">
            {{ errorText }}
          </div>
        }
        @if (editPhoneNumber && control.invalid && control.touched) {
          <div class="error">
            {{
              (control.errors?.maxlength
                ? 'app.common.errors.phone.length'
                : 'app.common.errors.phone.invalid'
              ) | translate
            }}
          </div>
        }
      </div>
    }
    <rt-group variant="horizontal" margin-bottom-small-xx>
      <rt-button (click)="onAdd()" variant="plain" size="small">
        <rt-icon name="add"> </rt-icon>
        <span>{{ 'app.common.add' | translate }}</span>
      </rt-button>
    </rt-group>
    <rt-divider></rt-divider>
    <rt-group margin-tb-small variant="horizontal">
      <rt-button
        [disabled]="arrayControls.invalid"
        [loading]="loading"
        (click)="onSave()"
        variant="primary"
        margin-right-small
      >
        {{ 'app.common.save' | translate }}
      </rt-button>
      <rt-button (click)="onCancel()" variant="plain">
        {{ 'app.common.cancel' | translate }}
      </rt-button>
    </rt-group>
  </div>
</div>
